import { gql } from '@apollo/client'

export const GENERATE_PUBLIC_TOKEN = gql`
  mutation generatePublicToken(
    $leadSourceId: Int!
    $stagePipelineId: Int!
    $campusId: Int
    $stagePipelineIntentId: Int
    $stagePipelineSignedId: Int
    $stagePipelineQuotedId: Int
    $agentId: Int
    $signatureFormEsId: Int
    $signatureFormEnId: Int
    $sendEmail: Boolean
    $sendSms: Boolean
    $requireIdentity: Boolean
    $sourceDescription: String
    $googleAdsIdEn: String
    $googleAdsIdEs: String
    $googleAdsPhoneEn: String
    $googleAdsPhoneEs: String
    $googleAdsLeadConversionIdEn: String
    $googleAdsLeadConversionIdEs: String
    $googleAdsConsentConversionIdEn: String
    $googleAdsConsentConversionIdEs: String
    $googleAdsQuoteConversionIdEn: String
    $googleAdsQuoteConversionIdEs: String
  ) {
    generatePublicToken(
      leadSourceId: $leadSourceId,
      stagePipelineId: $stagePipelineId,
      campusId: $campusId
      stagePipelineIntentId: $stagePipelineIntentId
      stagePipelineSignedId: $stagePipelineSignedId
      stagePipelineQuotedId: $stagePipelineQuotedId
      agentId: $agentId
      signatureFormEsId: $signatureFormEsId
      signatureFormEnId: $signatureFormEnId
      sendEmail: $sendEmail
      sendSms: $sendSms
      requireIdentity: $requireIdentity
      sourceDescription: $sourceDescription
      googleAdsIdEn: $googleAdsIdEn
      googleAdsIdEs: $googleAdsIdEs
      googleAdsPhoneEn: $googleAdsPhoneEn
      googleAdsPhoneEs: $googleAdsPhoneEs
      googleAdsLeadConversionIdEn: $googleAdsLeadConversionIdEn
      googleAdsLeadConversionIdEs: $googleAdsLeadConversionIdEs
      googleAdsConsentConversionIdEn: $googleAdsConsentConversionIdEn
      googleAdsConsentConversionIdEs: $googleAdsConsentConversionIdEs
      googleAdsQuoteConversionIdEn: $googleAdsQuoteConversionIdEn
      googleAdsQuoteConversionIdEs: $googleAdsQuoteConversionIdEs
    ) {
      success
      token
      errors {
        field
        message
      }
    }
  }
`
